import React from 'react'
import { ResultStyledComponent } from './styled'

const Result = (props) => {
  return (
    <ResultStyledComponent {...props} />
  )
}

export default Result
